<template>
  <div class="bottom-checkout-container">
    <img src="@/assets/confirmphone.png" class="logo-success" />
    <span class="message">We will send a SMS with redeem code details to:</span>
    <span class="phone">{{ phoneNumber }}</span>
    <div class="continue-button normal-button" @click="continueClick">
      <span class="continue-text">Confirmed</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "ConfirmAlert",
  components: {},
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
  },
  methods: {
    continueClick() {
      this.$emit("onConfirmed");
    },
  },
};
</script>
<style lang="scss" scoped>
.bottom-checkout-container {
  background-color: white;
  display: flex;
  flex-direction: column;

  .logo-success {
    width: auto;
    height: 100px;
    align-self: center;
    margin-top: 20px;
  }
  .message {
    font-size: 16px;
    font-family: "SFUIText-Medium", -apple-system;
    font-weight: 500;
    padding: 0 60px;
    align-self: center;
    margin-top: 30px;
    text-align: center;
  }
  .phone {
    font-size: 16px;
    font-family: "SFUIText-Bold", -apple-system;
    font-weight: bold;
    align-self: center;
    margin-top: 16px;
  }
  .continue-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-color: #2e2323;
    border-radius: 5px;
    margin-left: calc(50% - 250px);
    margin-right: calc(50% - 250px);
    margin-top: 30px;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 600px) {
    .continue-button {
      margin-left: 20px;
      margin-right: 20px;
    }
  }
  .continue-text {
    color: white;
    font-size: 16px;
    font-family: "SFUIText-Semibold", -apple-system;
    font-weight: 600;
  }
}
</style>